var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1133.9 1133.9",
    style: {
      enableBackground: "new 0 0 1133.9 1133.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#8B8B8B;}\r\n\t.st1{fill:#C2C1C1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.8,366.5l173.8-64.8l24.7,66.3l44.7-8.2l-43.1-115.7L391.7,357.5L495.8,366.5z M338.1,377.5l-145.3,54.2 l140.9,378l210.3-78.4l-69.8-21.8L360,752L250.4,458l91.5-34.1L338.1,377.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.9,329.9v403.4h537V329.9H326.9z M819.1,688.5H371.7V374.7h447.4V688.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.2,466.4c0,24.4,19.8,44.3,44.3,44.3v-88.5C436.1,422.1,416.2,442,416.2,466.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M730.7,490.9l0-0.1l-48.5,25.7l-46.8-65.1l-0.1-0.2l-70,127.1l-54.4-18.7l-0.1,0L426.1,652l-0.2,0.2h353.8 L730.7,490.9z M524.9,651.9L524.9,651.9L524.9,651.9L524.9,651.9z M426.8,651.8L426.8,651.8L426.8,651.8L426.8,651.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.4,421.2c-5-6.2-13.8-10.4-23.8-10.4c-7.5,0-14.4,2.3-19.5,6.2c-5.1-3.8-11.9-6.2-19.5-6.2 c-10,0-18.8,4.1-23.8,10.4c5.3-1.9,11.2-2.9,17.4-2.9c7.5,0,14.4,1.5,20.6,4.2c1.8,0.8,3.6,1.7,5.3,2.7c3.3,2,6.3,4.3,8.8,7 c-0.2-3.5-1.5-6.8-3.5-9.7c6.1-2.6,13.1-4.2,20.6-4.2C605.2,418.3,611.1,419.4,616.4,421.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.8,466.4c0,24.4-19.8,44.3-44.3,44.3v-88.5C484.9,422.1,504.8,442,504.8,466.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.9,836.2H443l13.6,25.9l5.2,11.5h0.3c-0.6-5.5-1.5-12.9-1.5-19v-18.4h11.2v52.2h-12.1l-13.6-26L441,851 h-0.3c0.6,5.8,1.5,12.7,1.5,18.9v18.5h-11.3V836.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.5,862.1c0-17,9.7-26.8,23.7-26.8c14.1,0,23.7,9.8,23.7,26.8c0,17-9.6,27.3-23.7,27.3 C491.2,889.4,481.5,879.1,481.5,862.1z M516.8,862.1c0-10.4-4.5-16.6-11.6-16.6c-7,0-11.6,6.2-11.6,16.6c0,10.5,4.6,17.1,11.6,17.1 C512.3,879.2,516.8,872.6,516.8,862.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.3,836.2h11.8v52.2h-11.8V836.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.3,836.2h12.5l8.7,23.4l3.1,9.1h0.3l3.1-9.1l8.5-23.4H628v52.2h-11v-19.1c0-5.1,1-12.7,1.5-17.8h-0.3 l-4.2,12.1l-8.1,20.2h-4.7l-8-20.2l-4.2-12.1h-0.3c0.6,5,1.5,12.6,1.5,17.8v19.1h-10.9V836.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M664.7,876h-16l-3.2,12.4h-12l16.4-52.2H664l16.4,52.2h-12.5L664.7,876z M662.3,866.8L661,862 c-1.4-5.2-2.8-11.4-4.2-16.8h-0.3c-1.2,5.5-2.6,11.6-4.1,16.8l-1.3,4.8H662.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M708.2,835.3c7.4,0,12.7,3.3,16.2,6.8l-6.5,7.3c-2.6-2.4-5.1-3.9-9.6-3.9c-8,0-13.8,6.3-13.8,16.8 c0,10.7,4.9,17,14.7,17c2.1,0,4.2-0.6,5.5-1.6v-9h-8.6V859h19.1v24c-3.8,3.3-10.2,6.3-17.5,6.3c-14.1,0-25.3-9.2-25.3-26.7 C682.6,845.4,694.1,835.3,708.2,835.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M735.9,836.2h32.7v9.9h-20.9v10.5h17.8v9.8h-17.8v12h21.7v9.9h-33.5V836.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.59642b26c25e4d316c09ff0a4eadd255.svg";
export { ForwardRef as ReactComponent };